import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddegressComponent } from 'src/app/components/egress/components/addegress/addegress.component';
import { AddSaleComponent } from 'src/app/components/sales/components/add-sale/add-sale.component';
import { AddVentaComponent } from 'src/app/components/sales/components/add-venta/add-venta.component';
import { Incidencia } from 'src/app/models/incidencia';
import { Venta } from 'src/app/models/venta';
import { ClienteService } from 'src/app/services/cliente.service';
import { IncidenciaService } from 'src/app/services/incidencia.service';
import { VentaService } from '../../../../services/venta.service';

@Component({
  selector: 'app-incidencias',
  templateUrl: './incidencias.component.html',
  styleUrls: ['./incidencias.component.css'],
  providers: [VentaService],
})
export class IncidenciasComponent implements OnInit {
  public ventas: any[];
  public filtrado: string = "todo";
  public incidencia: string = "ventas";
  public bloque: string = "productos";
  public clientes: any[];

  public sumaVentas: number;
  public saldoVentas: number;
  public ultimaSemana: number;
  public ultimoMes: number;

  public clientesArray: any[] = [];

  public isActive!: string;

  constructor(
    private _ventaService: VentaService,
    private _clienteService: ClienteService,
    private _incidenciaService: IncidenciaService,
    public dialog: MatDialog,
  ) {
    this.isActive = 'ventas';
  }

  ngOnInit(): void {
    this.getVentas();
    this.ingresoSemanal();
    this.getClientes();


    setTimeout(() => {
      // this.addVentaIncidencia(this.ventas)
      // this.recorrerClientes();
    }, 20000)
  }

  actualizarFiltrado(valor) {
    this.filtrado = valor;
  }

  getClientes() {
    this._clienteService.getClientes().subscribe(
      response => {
        if (response.clientesFiltrados) {
          this.clientes = response.clientesFiltrados;
          console.log(this.clientes)
        }
      },
      error => { console.log(<any>error); }
    )
  }

  getVentas() {
    this._ventaService.getVentas().subscribe(
      response => {
        if (response.ventasFiltrados) {
          this.ventas = response.ventasFiltrados;

          console.log(this.ventas)
          this.sumaVentas = this.ventas.reduce((acc, obj) => acc + obj.monto, 0);
          this.saldoVentas = this.ventas.reduce((acc, obj) => acc + obj.saldo, 0);
        }
      },
      error => { console.log(<any>error); }
    )
  }

  async recorrerClientes() {
    let clientes = [];

    for (const venta of this.ventas) {
      let cliente = await {
        nombre: venta.cliente,
        company: localStorage.getItem('TOKEN')
      }
      await clientes.push(cliente);
    }
    this.clientesArray = await this.eliminarDuplicados(clientes, 'nombre');
    await console.log(clientes)
  }


  async eliminarDuplicados(arr, prop) {
    let nuevoArray = [];
    let lookup = {};
    for (var i in arr) {
      lookup[arr[i][prop.toLowerCase()]] = await arr[i];
      // await console.log(arr[i][prop])
    }
    for (i in lookup) { await nuevoArray.push(lookup[i]); }
    await console.log(nuevoArray)

    for (const cliente of nuevoArray) {
      await this.newClient(cliente);
    }

    return await nuevoArray;
  }

  newClient(cliente) {
    this._clienteService.saveCliente(cliente).subscribe((response) => {
      console.log(response);
    })
  }

  async addVentaIncidencia(ventas: any) {
    if (ventas) {
      let ventas1 = ventas.slice(0, ventas.length + 1)
      console.log(ventas1)
      ventas1.forEach((element, index) => {
        this.newIncidencia(element, index);
      });
    }
  }

  async newIncidencia(element, index) {
    if (this.clientes) {

      let clienteUID = this.clientes.filter((cliente) => cliente.nombre == element.cliente)[0];
      // clienteUID = clienteUID._id;
      // if (clienteUID?._id) {
      // clienteUID = clienteUID._id;
      let incidencia: Incidencia = {
        fecha: element.fecha,
        cliente: element.cliente,
        company: element.company,
        descripcion: element.descripcion,
        entregado: element.entregado,
        pedido: element.pedido,
        monto: element.monto,
        saldo: element.saldo,
        type: 'venta',
        details: ''
      }
      if (clienteUID && clienteUID._id) incidencia.cliente_uid = clienteUID._id;

      // console.log(incidencia)
      await this._incidenciaService.saveIncidencia(incidencia).subscribe(
        response => {
          console.log(index)
          console.log(response)
        },
        error => {
          console.log(index)
          console.log(incidencia)
          console.log(error)
        }
      )
    }
    // }
  }

  seleccionarIncidencia(incidencia) {
    this.incidencia = incidencia;
  }

  seleccionarBloque(bloque) {
    this.bloque = bloque;
  }

  ingresoSemanal() {
    let semanaActual = new Date().getWeekNumber;
    this._ventaService.getVentas().subscribe(
      response => {
        let sumaSemana;
        if (response.ventasFiltrados) {
          let ventasFiltradasPorSemana = response.ventasFiltrados
            .filter(venta => (new Date(venta.fecha.slice(0, 10)).getWeekNumber()) === new Date().getWeekNumber());
          ventasFiltradasPorSemana = ventasFiltradasPorSemana.filter(venta => (new Date(venta.fecha).getFullYear()) === new Date().getFullYear());
          sumaSemana = ventasFiltradasPorSemana.reduce((acc, obj) => acc + obj.monto, 0);
          this.ultimaSemana = sumaSemana;

        }
      }
    )
  }

  // addSale() {
  //   const dialogRef = this.dialog.open(AddSaleComponent);
  //   dialogRef.afterClosed().subscribe(result => { this.ngOnInit(); });
  // }

  addSale() {
    const dialogRef = this.dialog.open(AddVentaComponent);
    dialogRef.afterClosed().subscribe(result => { this.ngOnInit(); });
  }

  addEgress() {
    const dialogRef = this.dialog.open(AddegressComponent);
    dialogRef.afterClosed().subscribe(result => { this.ngOnInit(); });
  }

  active(valor) {
    this.isActive = valor;
  }

}
